import { render } from "./APToFactoryDispatch.vue?vue&type=template&id=ffb6fe00&scoped=true"
import script from "./APToFactoryDispatch.vue?vue&type=script&lang=js"
export * from "./APToFactoryDispatch.vue?vue&type=script&lang=js"

import "./APToFactoryDispatch.vue?vue&type=style&index=0&id=ffb6fe00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb6fe00"]])

export default __exports__